import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { DsAbstractLoadingComponent } from '@abstract/components/ds-abstract-loading.component';

@Component({
  selector: 'ds-loading-dots',
  standalone: true,
  imports: [NgClass],
  templateUrl: './ds-loading-dots.component.html',
  styleUrls: ['./ds-loading-dots.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/**
 * Three-dot pulse loading indicator. Shared size, theme, color, and aria inputs
 * come from `DsAbstractLoadingComponent`.
 */
export class DsLoadingDotsComponent extends DsAbstractLoadingComponent {}
